/**
 * @generated SignedSource<<6086f3e153e45f608f9c050db7cbd525>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoveStartContentConfigInput = {
  clientMutationId?: string | null | undefined;
  configId: string;
  contentNodeId: string;
};
export type StartContentConfigEditor_RemoveStartTreeConfigMutation$variables = {
  input: RemoveStartContentConfigInput;
};
export type StartContentConfigEditor_RemoveStartTreeConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly removeStartContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"StartContentConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type StartContentConfigEditor_RemoveStartTreeConfigMutation = {
  response: StartContentConfigEditor_RemoveStartTreeConfigMutation$data;
  variables: StartContentConfigEditor_RemoveStartTreeConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartContentConfigEditor_RemoveStartTreeConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "RemoveStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "removeStartContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "StartContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StartContentConfigEditor_RemoveStartTreeConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "RemoveStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "removeStartContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isStartContentConfig"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "requiredUserStatuses",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SpecifiedUserStatusesCanStartContentConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1ff00bfabe335c12420c932d1376cb42",
    "id": null,
    "metadata": {},
    "name": "StartContentConfigEditor_RemoveStartTreeConfigMutation",
    "operationKind": "mutation",
    "text": "mutation StartContentConfigEditor_RemoveStartTreeConfigMutation(\n  $input: RemoveStartContentConfigInput!\n) {\n  Admin {\n    Tree {\n      removeStartContentConfig(input: $input) {\n        contentNode {\n          ...StartContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectExtendStartContentConfigEditDialogs_StartContentConfigFragment on StartContentConfig {\n  __isStartContentConfig: __typename\n  configType\n  ...SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment\n}\n\nfragment ProjectExtendStartContentConfigEditDialogs_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      startConfigs {\n        __typename\n        configType\n        ... on SpecifiedUserStatusesCanStartContentConfig {\n          requiredUserStatuses\n          dateTime\n        }\n        ...SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment\n        id\n      }\n    }\n  }\n  ...SpecificUserStatusesCanStartContentConfigForm_TreeNodeFragment\n}\n\nfragment SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment on StartContentConfig {\n  __isStartContentConfig: __typename\n  ... on SpecifiedUserStatusesCanStartContentConfig {\n    id\n    configType\n    dateTime\n    requiredUserStatuses\n  }\n}\n\nfragment SpecificUserStatusesCanStartContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      startConfigs {\n        __typename\n        ...SpecificUserStatusesCanStartContentConfigForm_StartContentConfigFragment\n        id\n      }\n    }\n  }\n}\n\nfragment StartContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      startConfigs {\n        __typename\n        id\n        configType\n        ... on SpecifiedUserStatusesCanStartContentConfig {\n          dateTime\n        }\n        ...ProjectExtendStartContentConfigEditDialogs_StartContentConfigFragment\n      }\n    }\n  }\n  ...ProjectExtendStartContentConfigEditDialogs_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "4b6b3f90709a9ac61785ea17142908c1";

export default node;
